import ReviewActivityPage from './pages/ReviewActivityPage';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { OrganizationProvider } from './contexts/OrganizationContext';
import { SidebarProvider } from './contexts/SidebarContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import UserDashboard from './pages/UserDashboard';
import AdminPanel from './pages/AdminPanel';
import DocumentReview from './pages/DocumentReview';
import UserDocumentDetail from './pages/UserDocumentDetail';
import UserManagement from './pages/UserManagement';
import Categories from './pages/Categories';
import DocumentDefinitions from './pages/DocumentDefinitions';
import Profile from './pages/Profile';
import ResetPassword from './pages/ResetPassword';
import ForgotPassword from './pages/ForgotPassword';
import NotFound from './pages/NotFound';
import UserDocumentation from './pages/UserDocumentation';
import AdminDocumentation from './pages/AdminDocumentation';
import AdminReport from './pages/AdminReport';

function App() {
  return (
    <AuthProvider>
      <OrganizationProvider>
      <SidebarProvider>
        <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          {/* Self-registration is closed: suppliers join through invitations. */}
          <Route path="/register" element={<Navigate to="/login" replace />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Protected routes - Normal users */}
          <Route
            path="/"
            element={
              <ProtectedRoute requiredRole="normal">
                <UserDashboard />
              </ProtectedRoute>
            }
          />
          
          {/* Protected routes - Admin Dashboard */}
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute requiredRole={['admin', 'reviewer']}>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/help"
            element={
              <ProtectedRoute>
                <UserDocumentation />
              </ProtectedRoute>
            }
          />

          {/* Protected routes - Admin only */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminPanel />
              </ProtectedRoute>
            }
          />
          <Route path="/admin/activity" element={<ProtectedRoute requiredRole={['admin', 'reviewer']}><ReviewActivityPage /></ProtectedRoute>} />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute requiredRole={['admin', 'reviewer']}>
                <UserManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/categories"
            element={
              <ProtectedRoute requiredRole="admin">
                <Categories />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/definitions"
            element={
              <ProtectedRoute requiredRole="admin">
                <DocumentDefinitions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/help"
            element={
              <ProtectedRoute requiredRole={['admin', 'reviewer']}>
                <AdminDocumentation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/report"
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminReport />
              </ProtectedRoute>
            }
          />

          {/* Protected routes - Admin and Reviewer */}
          <Route
            path="/review"
            element={
              <ProtectedRoute requiredRole={['admin', 'reviewer']}>
                <DocumentReview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/review/:userId"
            element={
              <ProtectedRoute requiredRole={['admin', 'reviewer']}>
                <UserDocumentDetail />
              </ProtectedRoute>
            }
          />

          {/* Catch all */}
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </Router>
      </SidebarProvider>
      </OrganizationProvider>
    </AuthProvider>
  );
}

export default App;